<template>

    <div v-if="!requisicoes.finalizado" class="loading-overlay">
        <div class="spinner"></div>
    </div>


    <div v-if="requisicoes.finalizado">
        <!-- Info Banner -->
        <div class="form-info-banner">
            <h3 class="form-info-banner-title">Os campos com * são de preenchimento obrigatório</h3>
            <p class="form-info-banner-text">Caso queira, você poderá salvar e continuar depois.</p>
        </div>

        <!-- Seção: Documentos -->
        <section class="form-section">
            <div class="form-section-header">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Documentos'"
                    :TipoCliente="tipoCliente" :Sessao="'Documentos'" :SubSessao="'Documentos'" />
                <p class="text-sm text-gray-600 dark:text-gray-400 mt-2">
                    Todos os arquivos marcados como obrigatórios deverão ser anexados
                </p>
            </div>
            <div class="form-section-content">
                <div class="form-subsection">
                    <h4 class="form-subsection-title">
                        <i class="fa fa-upload"></i>
                        Upload de Arquivos
                    </h4>
                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="tipoCadastro">Tipo de documento</label>
                            <div class="flex gap-4 items-end">
                                <div class="flex-1">
                                    <select id="tipoCadastro" class="field" v-model="TipoDocumento">
                                        <option value="">Selecione</option>
                                        <option v-for="item in listaDocumentosFiltrados" :key="item.Id" :value="item.Id">
                                            {{ item.Nome }}{{ item.Obrigatorio == 'Sim' ? ' - Obrigatório' : '' }}
                                        </option>
                                    </select>
                                </div>
                                <div v-for="(documento, index) in listaDocumentosFiltradosComTipo" :key="index">
                                    <input type="file" 
                                        :id="'fileInput' + index" 
                                        :ref="'fileInput' + index"
                                        :accept="configTipo.acceptTypes"
                                        style="display: none" 
                                        @change="handleFileChange($event, documento.Id)">
                                    
                                    <button class="btn-primary" 
                                            @click.prevent="triggerFileInput(index)">
                                        <i class="fa fa-upload mr-2"></i>
                                        Anexar arquivo
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Seção: Documentos Anexados -->
        <section class="form-section" v-if="arquivos.length > 0">
            <div class="form-section-header">
                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Documentos Anexados</h3>
            </div>
            <div class="form-section-content">
                <div class="hidden md:block overflow-x-auto">
                    <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead class="bg-gray-50 dark:bg-gray-800">
                            <tr>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Tipo de documento</th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Nome do arquivo</th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Data/Hora</th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Ações</th>
                            </tr>
                        </thead>
                        <tbody v-if="requisicoes.listaDocumentosUploadEfetuado" class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                            <tr v-for="(arquivo, index) in arquivos" :key="index" class="hover:bg-gray-50 dark:hover:bg-gray-800">
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{ getNomeDoDocumento(arquivo.TipoDocumentoId) }}</td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{ arquivo.FileName }}</td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{ formatDateTime(arquivo.InsertDate) }}</td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm">
                                    <button 
                                        v-if="!Edicao"
                                        @click.stop.prevent="excluirArquivo(arquivo, index)" 
                                        :disabled="deletando == index"
                                        :class="{ 'opacity-50 cursor-not-allowed': deletando == index }"
                                        class="text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300 focus:outline-none"
                                        title="Deletar arquivo">
                                        <i v-if="deletando != index" class="fa fa-trash"></i>
                                        <i v-if="deletando == index" class="fa fa-spinner fa-spin"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>

                        <tbody v-if="!requisicoes.listaDocumentosUploadEfetuado" class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                            <tr v-for="(arquivo, index) in arquivos" :key="index">
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{ getNomeDoDocumento(arquivo.TipoDocumentoId) }}</td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{ arquivo.FileName }}</td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{ formatDateTime(arquivo.InsertDate) }}</td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm"></td>
                            </tr>
                            <tr v-for="i in 1" :key="'loading-'+i">
                                <td colspan="4" class="px-6 py-4"><div class="shimmer h-4 w-full rounded"></div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <!-- Versão mobile da grid -->
                <div class="block md:hidden">
                    <div class="rows__carteiras">
                        <div class="header__row">
                            <div class="widget">
                                <p>Tipo de documento</p>
                            </div>
                            
                            <div class="widget">
                                <p>Nome do arquivo</p>
                            </div>
                            
                            <div class="widget">
                                <p>Data/Hora</p>
                            </div>
                        </div>
                        
                        <!-- Conteúdo para quando os documentos já foram carregados -->
                        <div v-if="requisicoes.listaDocumentosUploadEfetuado">
                            <div v-for="(arquivo, index) in arquivos" :key="index"
                                class="row__client">
                                <div class="info__client">                                
                                    <div class="widget">
                                        <p class="title__mobile">Tipo de documento</p>
                                        <p>{{ getNomeDoDocumento(arquivo.TipoDocumentoId) }}</p>
                                    </div>
                                    
                                    <div class="widget">
                                        <p class="title__mobile">Nome do arquivo</p>
                                        <p>{{ arquivo.FileName }}</p>
                                    </div>
                                    
                                    <div class="widget">
                                        <p class="title__mobile">Data/Hora</p>
                                        <p>{{ formatDateTime(arquivo.InsertDate) }}</p>
                                    </div>
                                    
                                    <div class="widget icons" v-if="!Edicao" style="display: inline-flex">
                                        <a @click.stop.prevent="excluirArquivo(arquivo, index)" 
                                            title="Deletar arquivo" 
                                            :class="{ 'disabled': deletando == index }"
                                            style="margin-left: 5px; position: relative; display: inline-block;">
                                            <i class="ico__delete" v-if="deletando != index" style="display: inline-block;"></i>
                                            <i v-if="deletando == index" class="loading-spinner-button" style="display: inline-block;"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Conteúdo para carregamento inicial -->
                        <div v-if="!requisicoes.listaDocumentosUploadEfetuado">
                            <div v-for="(arquivo, index) in arquivos" :key="index"
                                class="row__client">
                                <div class="info__client">                                
                                    <div class="widget">
                                        <p class="title__mobile">Tipo de documento</p>
                                        <p>{{ getNomeDoDocumento(arquivo.TipoDocumentoId) }}</p>
                                    </div>
                                    
                                    <div class="widget">
                                        <p class="title__mobile">Nome do arquivo</p>
                                        <p>{{ arquivo.FileName }}</p>
                                    </div>
                                    
                                    <div class="widget">
                                        <p class="title__mobile">Data/Hora</p>
                                        <p>{{ formatDateTime(arquivo.InsertDate) }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="shimmer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <ModalAlerta :mostrar="modalAlerta.mostrar" :tipo="modalAlerta.tipo" :titulo="modalAlerta.titulo" :mensagem="modalAlerta.mensagem" @fechar="modalAlerta.mostrar = false" />
    </div>
</template>


<script>

import api from '@/api/axios';
import { mapGetters } from 'vuex';
import formatData from '@/utils/formatData';
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'
import ModalAlerta from '../Utilitarios/ModalAlerta.vue';

export default {
    mixins: [formatData],
    components: { LabelDisclaimer, ModalAlerta },
    name: 'UploadDocumentosShared',
    props: {
        tipoCliente: {
            type: String,
            required: true,
            validator: (value) => ['Pessoa Física', 'Pessoa Jurídica', 'Fundos'].includes(value)
        },
        Edicao: Boolean
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaDocumentos: 'GET_LISTA_DOCUMENTOS_UPLOAD',
            listaDocumentosUploadEfetuado: 'GET_LISTA_DOCUMENTOS_UPLOAD_REALIZADO'
        }),
        listaDocumentosFiltrados() {
            return this.listaDocumentos.filter(
                documento => documento.TipoCliente === this.tipoCliente || documento.TipoCliente === 'Todos'
            );
        },
        listaDocumentosFiltradosComTipo() {
            return this.listaDocumentos.filter(
                documento => (documento.TipoCliente === this.tipoCliente || documento.TipoCliente === 'Todos') && documento.Id == this.TipoDocumento
            );
        },
        configTipo() {
            return {
                'Pessoa Física': {
                    storeMutation: 'SET_PF_SALVAR_INFO',
                    proximaEtapa: 6,
                    iOSWorkaround: false,
                    acceptTypes: null
                },
                'Pessoa Jurídica': {
                    storeMutation: 'SET_PJ_SALVAR_INFO',
                    proximaEtapa: 7,
                    iOSWorkaround: true,
                    acceptTypes: 'image/*,application/pdf'
                },
                'Fundos': {
                    storeMutation: 'SET_FI_SALVAR_INFO',
                    proximaEtapa: 6,
                    iOSWorkaround: false,
                    acceptTypes: null
                }
            }[this.tipoCliente];
        }
    },
    data() {
        return {
            modalAlerta: { mostrar: false, tipo: 'warning', titulo: '', mensagem: '' },
            permitirAvancar: false,
            TipoDocumento: "",
            deletando: -1,
            requisicoes: {
                listaDocumentos: false,
                listaDocumentosUploadEfetuado: false,
                finalizado: false
            },
            arquivosUpload: [],
            arquivos: [],
            arquivo: {
                TipoDocumentoId: '',
                FileName: '',
                Descricao: '',
                FileDataString64: '',
                UsuarioInsert: '',
                Data: new Date()
            },
        }
    },
    created() {
        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD');
        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO');
    },
    mounted() {
        this.executarListagemUploads();
    },
    watch: {
        listaDocumentosUploadEfetuado() {
            this.executarListagemUploads();
        },
        listaDocumentos() {
            this.verificarSeRequisicoesFinalizaram('listaDocumentos')
        }
    },
    methods: {
        executarListagemUploads(){
            this.verificarSeRequisicoesFinalizaram('listaDocumentos');
            this.verificarSeRequisicoesFinalizaram('listaDocumentosUploadEfetuado');
            if (this.listaDocumentosUploadEfetuado != null) {
                this.arquivosUpload = [];
                this.arquivos = this.listaDocumentosUploadEfetuado;
            }
            this.validarFormulario();
        },
        verificarSeRequisicoesFinalizaram(requisicao) {
            if (requisicao == 'listaDocumentos') {
                this.requisicoes.listaDocumentos = true;
            } else if (requisicao == 'listaDocumentosUploadEfetuado') {
                this.requisicoes.listaDocumentosUploadEfetuado = true;
            }

            if (this.requisicoes.listaDocumentosUploadEfetuado && this.requisicoes.listaDocumentos) {
                this.requisicoes.finalizado = true;
            }
        },
        getNomeDoDocumento(tipoDocumentoId) {
            const documento = this.listaDocumentos.find(doc => doc.Id === tipoDocumentoId);
            return documento ? documento.Nome : 'Documento não encontrado';
        },
        validarFormulario(submeter) {
            // Guard: se lista de documentos não foi carregada, não pode validar
            if (!this.listaDocumentos || this.listaDocumentos.length === 0) {
                if (submeter) {
                    this.modalAlerta = {
                        mostrar: true,
                        tipo: 'warning',
                        titulo: 'Aguarde',
                        mensagem: 'Carregando lista de documentos...'
                    };
                }
                return false;
            }

            this.permitirAvancar = true;
            var nomeDoCampo = '';

            this.listaDocumentos.forEach(obj => {
                const isDoTipo = obj.TipoCliente === this.tipoCliente || obj.TipoCliente === 'Todos';
                
                if (isDoTipo && obj.Obrigatorio === 'Sim') {
                    if (!this.arquivos.some(arquivo => arquivo.TipoDocumentoId === obj.Id)) {
                        if (this.permitirAvancar) {
                            nomeDoCampo = obj.Nome;
                        }
                        this.permitirAvancar = false;
                    }
                }
            });

            if (submeter && nomeDoCampo != '') {
                this.modalAlerta = { mostrar: true, tipo: 'warning', titulo: 'Atenção: Documento obrigatório', mensagem: `O documento ${nomeDoCampo} é obrigatório e não foi enviado, envie o documento para avançar` };
            }

            return this.permitirAvancar;
        },
        proximaEtapa() {
            if (this.validarFormulario(true)) {
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.$store.commit(this.configTipo.storeMutation, true);
                this.$store.commit('SET_ETAPA_CADASTRO', this.configTipo.proximaEtapa);
            }
        },
        triggerFileInput(index) {
            const fileInput = this.$refs['fileInput' + index] && this.$refs['fileInput' + index][0];
            
            if (!fileInput) return;
            
            if (this.configTipo.iOSWorkaround) {
                // Workaround para iOS Safari (Pessoa Jurídica)
                const originalDisplay = fileInput.style.display;
                fileInput.style.display = 'block';
                fileInput.style.position = 'absolute';
                fileInput.style.opacity = '0.01';
                fileInput.style.zIndex = '9999';
                
                setTimeout(() => {
                    const event = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: true
                    });
                    fileInput.dispatchEvent(event);
                    
                    setTimeout(() => {
                        fileInput.style.display = originalDisplay;
                    }, 200);
                }, 50);
            } else {
                // Click direto (Pessoa Física e Fundos)
                fileInput.click();
            }
        },
        async excluirArquivo(arquivo, index) {
            this.deletando = index;

            await api.post(`/cliente/documentos/excluir`, arquivo)
                .then((retorno) => {
                    this.deletando = -1;

                    if (retorno.status == 200) {
                        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO');

                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Arquivo informado foi excluído.',
                        });

                        this.validarFormulario();
                    } else {
                        this.$swal({
                            icon: 'error',
                            title: 'Erro',
                            text: `Falha ao realizar exclusão do arquivo.`,
                        });
                    }
                })
                .catch((error) => {
                    this.deletando = -1;
                    this.$swal({
                        icon: 'error',
                        title: 'Falha ao realizar exclusão do arquivo.',
                        text: `${error.response.data.data[0]}`,
                    });
                });

            this.validarFormulario();
        },
        salvarAlteracoesLocalmente() {
            try {
                this.$store.commit('SET_SALVAR_INFO_UPLOAD', this.arquivosUpload);
                this.validarFormulario();
                
                if (!this.Edicao) {
                    this.requisicoes.listaDocumentosUploadEfetuado = false;
                    this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                    this.salvar();
                } else {
                    if (this.arquivosUpload && this.arquivosUpload.length > 0) {
                        this.arquivos.push(...this.arquivosUpload);
                        this.arquivosUpload = [];
                    }
                }
            } catch (error) {
                console.error('Erro ao salvar alterações localmente:', error);
                this.$swal({
                    icon: 'error',
                    title: 'Erro',
                    text: error.message,
                });
            }
        },
        salvar() {
            this.$store.commit(this.configTipo.storeMutation, true);
        },
        handleFileChange(event, id) {
            const file = event.target.files[0];
            
            if (!file) {
                console.error('Nenhum arquivo selecionado');
                return;
            }
            
            const fileName = file.name;
            const reader = new FileReader();
            
            reader.onerror = (error) => {
                console.error('Erro ao ler o arquivo:', error);
                this.$swal({
                    icon: 'error',
                    title: 'Erro no upload',
                    text: 'Houve um problema ao processar o arquivo. Por favor, tente novamente.',
                });
            };
            
            reader.onabort = () => {
                console.warn('Leitura de arquivo cancelada');
            };
            
            reader.onload = (e) => {
                try {
                    const base64String = e.target.result;
                    
                    if (typeof base64String !== 'string') {
                        throw new Error('Resultado inválido da leitura do arquivo');
                    }
                    
                    let base64Data = base64String;
                    if (base64String.includes(',')) {
                        base64Data = base64String.split(',')[1];
                    }
                    
                    this.novoArquivo = {
                        TipoDocumentoId: id,
                        FileName: fileName,
                        Descricao: '',
                        FileDataString64: base64Data,
                        UsuarioInsert: this.user.NomeRazaoSocial,
                        timestamp: new Date().getTime()
                    };
                    
                    this.arquivosUpload.push({ ...this.novoArquivo });
                    this.TipoDocumento = '';
                    this.salvarAlteracoesLocalmente();

                } catch (error) {
                    console.error('Erro ao processar arquivo:', error);
                    this.$swal({
                        icon: 'error',
                        title: 'Erro no processamento',
                        text: 'Não foi possível processar o arquivo selecionado.',
                    });
                }
            };
            
            setTimeout(() => {
                reader.readAsDataURL(file);
            }, 100);
            
            setTimeout(() => {
                event.target.value = null;
            }, 200);
        }
    }
}

</script>


<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
</style>
